import moment from "moment";
import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import { Helmet } from "react-helmet";
import Chart from "react-apexcharts";
import { Link, useLocation, useNavigate } from "react-router-dom";
import shortid from "shortid"
import { DatePicker, Tooltip, message, TimePicker } from "antd";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import AttendanceService from "../../../Services/AttendanceService";
import LeaveApplicationService from "../../../Services/LeaveApplicationService";
import LeaveEntitlementService from "../../../Services/LeaveEntitlementService";
import HolidayServices from "../../../Services/HolidayService";
import LeavetypeService from "../../../Services/PolicyServices";
import DataParser from "../../../utlits/Dataparser";
import Sidebar from "../../Layouts/Sidebar-old";
import { TbListDetails } from "react-icons/tb";
import SocketService from "../../../Services/SocketService";
import AddLeaves from "../Leaves/AddLeaves";
import UserServices from "../../../Services/UserService";
import { FaCakeCandles } from "react-icons/fa6";
import PastDaysService from "../../../Services/PastDaysService";


const AttendanceEmploye = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [emprole, setEmpRole] = useState("");
  const [apiUser, setApiUser] = useState(null);
  const [attendanceList, setAttendenceList] = useState([]);
  const [overtimeSummary, setOvertimeSummary] = useState(null);
  const [userEntitlementList, setUserEntitlementsList] = useState([]);
  const [userLeaves, setUserLeaves] = useState([]);
  const [userLeaveDates, setUserLeaveDates] = useState([]);
  const [userLeaveDatesWorkHours, setUserLeaveDatesWorkHours] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [workFromHome, setWorkFromHome] = useState(null);
  const [status, setStatus] = useState(null);
  const [isDisabled, setIsDisable] = useState(null);
  const [isOvertimeEnabled, setIsOvertimeEnabled] = useState(true);
  const [updatePunchIn, setUpdatePunchIn] = useState(null);
  const [updatePunchOut, setUpdatePunchOut] = useState(null);
  const [editId, setEditId] = useState(null);
  const [selectMonth, setSelectMonth] = useState(moment().format("MM"));
  const [selectYear, setSelectYear] = useState(moment().format("YYYY"));
  const compId = DataParser.CompanyId();
  const userid = DataParser.UserId();
  const currentDate = DataParser.getDateinFormat();
  const currentTime = DataParser.getCurrentTime();

  const [start, setStartDate] = useState("");
  const [end, setEndDate] = useState("");
  const [overtimeData, setOvertimeData] = useState(null);

  const [isOvertimeLoading, setIsOvertimeLoading] = useState(false);
  const [isAdjustmentProcessing, setAdjustmentProcessing] = useState(false);
  const [isAdjusted, setIsAdjusted] = useState(false);
  const [empName, setEmpName] = useState("");

  //Statistics and todays activity

  const [activityCheckin, setActivityCheckin] = useState(null);
  const [activityCheckout, setActivityCheckout] = useState(null);
  const [activityDate, setActivityDate] = useState(null); // 🟢 Record Date State

  const [appliedMonth, setAppliedMonth] = useState(null);
  const [appliedYear, setAppliedYear] = useState(null);
  const appliedMonthRef = React.useRef(null);
  const appliedYearRef = React.useRef(null);

  const [punchineligibility, setPunchInEligibility] = useState("")
  const [dynamicTargets, setDynamicTargets] = useState({ daily: null, monthly: null });
  const [isTargetsLoading, setIsTargetsLoading] = useState(false);
  const [leaveBalances, setLeaveBalances] = useState([]);
  const [targetMaritalStatus, setTargetMaritalStatus] = useState("");
  const [absentCount, setAbsentCount] = useState(0);
  const [todayTotalHours, setTodayTotalHours] = useState(0);
  const [todayLunchTimes, setTodayLunchTimes] = useState([]);
  const [todayExpectedHours, setTodayExpectedHours] = useState(null);
  const [selectedAbsentDate, setSelectedAbsentDate] = useState(null);
  const [pastDaysLimit, setPastDaysLimit] = useState(0);
  const [punchLoading, setPunchLoading] = useState({ in: false, out: false });
  const [upcomingBirthday, setUpcomingBirthday] = useState([]);
  const [tick, setTick] = useState(0); // 🟢 Real-time updater state

  // 🟢 Real-time Attendance Updater
  // Forces component to re-render every minute to update "getTodayHours" and "getDecimalHours"
  useEffect(() => {
    let interval = null;
    // Only run the timer if the user is currently punched in but not punched out.
    if (activityCheckin && (!activityCheckout || activityCheckout === "")) {
      interval = setInterval(() => {
        setTick((prev) => prev + 1);
      }, 60000); // 60 seconds
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [activityCheckin, activityCheckout]);

  //csv link
  const headersCsv = [
    { label: "Date", key: "date" },
    { label: "Punch In", key: "timein" },
    { label: "Punch Out", key: "timeout" },
    { label: "Working Hours", key: "totalhours" },
  ];




  const handleSearchOvertime = async (isSilent = false) => {
    try {
      if (!isSilent) setIsOvertimeLoading(true);

      if (!start || !end) {
        message.warning("Please select both start and end date.");
        if (!isSilent) setIsOvertimeLoading(false);
        return;
      }

      const startDateSelect = moment(start);
      const endDateSelect = moment(end);

      if (!startDateSelect.isSame(endDateSelect, "month")) {
        message.warning("Please select a date range within the same month.");
        if (!isSilent) setIsOvertimeLoading(false);
        return;
      }

      const empId = location.state ? location.state.data : userid;

      const res = await AttendanceService.getOvertimeReport({
        empid: empId,
        company_id: compId,
        start: startDateSelect.format("YYYY-MM-DD"),
        end: endDateSelect.format("YYYY-MM-DD")
      });

      // ✅ Save entire response (contains summary and details)
      if (res?.success) {
        setOvertimeData(res);
      } else {
        setOvertimeData(null);
        message.error(res?.message || "Failed to fetch overtime report");
      }

    } catch (error) {
      console.error("Overtime fetch error:", error);
      message.error("An error occurred while fetching report.");
    } finally {
      if (!isSilent) setIsOvertimeLoading(false);
    }
  };

  const handleManualAdjustment = async () => {
    if (!start || !end) {
      message.warning("Please select a date range first.");
      return;
    }

    try {
      const empId = location.state ? location.state.data : userid;

      setAdjustmentProcessing(true);
      const res = await AttendanceService.manualAdjustment({
        empid: empId,
        company_id: compId,
        start: moment(start).format("YYYY-MM-DD"),
        end: moment(end).format("YYYY-MM-DD")
      });

      if (res?.success) {
        message.success("Overtime adjustment processed successfully.");
        setIsAdjusted(true);

        // 🟢 Notify via Socket (Restore real-time update)
        SocketService.emit("attendance_update", { company_id: compId, user_id: empId });

        // 🔄 Auto-refresh the modal report table so user sees updated data instantly
        // Small delay to ensure backend DB writes are fully committed before re-fetching
        setTimeout(() => {
          handleSearchOvertime(true);
        }, 800);
      } else {
        if (res?.message?.toLowerCase().includes("already") || res?.message?.toLowerCase().includes("processed")) {
          message.info("The period you selected have already been adjusted either bu manual or by auto");
        } else {
          message.error(res?.message || "Adjustment failed");
        }
      }
    } catch (error) {
      console.error("Adjustment error:", error);
      message.error("An error occurred during adjustment.");
    } finally {
      setAdjustmentProcessing(false);
    }
  };


  useEffect(() => {
    const modalEl = document.getElementById("viewOvertimeReportModal");

    // When modal hides, reset form + data
    const handleModalHide = () => {
      setStartDate("");
      setEndDate("");
      setOvertimeData(null);
      setIsAdjusted(false);
    };

    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleModalHide);
    }

    // Cleanup
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleModalHide);
      }
    };
  }, []);


  useEffect(() => {
    // Determine the month/year to display on land
    let currentMonth = moment().format("MM");
    let currentYear = moment().format("YYYY");

    if (location.state !== null) {
      const stateData = location?.state?.data;
      const stateName = location.state?.name;
      const stateMonth = location.state?.month;
      const stateYear = location.state?.year;

      if (stateName) setEmpName(stateName);
      setApiUser(stateData);
      getUserEntitlements(stateData, compId);
      getUserLeaves(stateData, compId);

      // If redirected with specific month/year, respect them 
      if (stateMonth && stateYear) {
        currentMonth = String(stateMonth).padStart(2, '0');
        currentYear = String(stateYear);
        setSelectMonth(currentMonth);
        setSelectYear(currentYear);
        setAppliedMonth(currentMonth);
        setAppliedYear(currentYear);
        appliedMonthRef.current = currentMonth;
        appliedYearRef.current = currentYear;

        refreshAttendanceData(); // Fetch selected month directly
      } else {
        setSelectMonth(currentMonth);
        setSelectYear(currentYear);
        setAppliedMonth(currentMonth);
        setAppliedYear(currentYear);
        appliedMonthRef.current = currentMonth;
        appliedYearRef.current = currentYear;
        getAttendenceById(compId, stateData);
      }
    } else {
      setSelectMonth(currentMonth);
      setSelectYear(currentYear);
      setAppliedMonth(currentMonth);
      setAppliedYear(currentYear);
      appliedMonthRef.current = currentMonth;
      appliedYearRef.current = currentYear;
      getAttendence();
      getUserEntitlements(userid, compId);
      getUserLeaves(userid, compId);

      const usernamee = DataParser.CompanyUserName();
      setEmpName(usernamee);
    }

    checkPunchIns();

    HolidayServices.getLatestHomeHolidays(compId)
      .then((res) => {
        if (res.Good) {
          setHolidays(res.data);
        }
      })
      .catch((err) => console.error("Error fetching holidays:", err));

    // Fetch Leave Balances
    const targetEmpId = location.state ? location.state.data : userid;
    LeavetypeService.getUserLeavePolicy(compId, targetEmpId).then((res) => {
      if (res?.success) {
        setLeaveBalances(res.data || []);
        setAbsentCount(res.absent_count || 0);
      } else if (Array.isArray(res)) {
        setLeaveBalances(res);
      } else {
        setLeaveBalances([]);
      }
    })
      .catch((err) => console.error("Error fetching leave balances:", err));

    // 🟢 Socket Integration
    SocketService.connect();

    const handleAttendanceUpdate = (data) => {
      // Check if update is for this company and (optional) specific user
      if (String(data.company_id) === String(compId)) {
        // If viewing specific employee (HR view of emp) or own profile
        const targetEmpId = location.state ? location.state.data : userid;

        if (data.user_id === targetEmpId || !data.user_id) {
          console.log("🔔 Real-time attendance update received:", data);

          if (location.state !== null) {
            refreshAttendanceData();
          } else {
            refreshAttendanceData();
          }
          checkPunchIns();

          // NOTE: handleSearchOvertime is NOT called here intentionally.
          // The handleManualAdjustment function manages its own delayed refresh (800ms)
          // after the DB write completes. Calling it here races against the DB write
          // and can display stale (pre-adjustment) data in the modal.
        }
      }
    };

    const handleLeaveUpdate = (data) => {
      if (String(data.company_id) === String(compId)) {
        const targetEmpId = location.state ? location.state.data : userid;
        if (String(data.user_id) === String(targetEmpId)) {
          console.log("🔔 Leave update received, refreshing balances & attendance:", data);

          // 🟢 Refresh Attendance List (To update Absent -> Leave status)
          refreshAttendanceData();

          // Refetch leave balances
          LeavetypeService.getUserLeavePolicy(compId, targetEmpId)
            .then((res) => {
              if (res?.success) {
                setLeaveBalances(res.data || []);
                setAbsentCount(res.absent_count || 0);
              } else if (Array.isArray(res)) {
                setLeaveBalances(res);
              } else {
                setLeaveBalances([]);
              }
            })
            .catch((err) => console.error("Error refreshing leave balances:", err));
        }
      }
    };

    const handleStatsUpdate = (data) => {
      if (String(data.company_id) === String(compId)) {
        const targetEmpId = location.state ? location.state.data : userid;
        if (String(data.user_id) === String(targetEmpId)) {
          console.log("📊 Real-time stats update received:", data);

          // 🔑 GUARD: Only update the dashboard overtime stats if the socket
          // event is for the SAME month the user is currently viewing.
          // If HR adjusts February while viewing April, the dashboard should
          // NOT overwrite April's worked hours / OT totals with February's.
          const displayedMonth = `${appliedYearRef.current || moment().format("YYYY")}-${String(appliedMonthRef.current || moment().format("MM")).padStart(2, '0')}`;
          const isSameMonth = !data.adjusted_month || data.adjusted_month === displayedMonth;

          if (isSameMonth && data.overtimeSummary) {
            setOvertimeSummary(data.overtimeSummary);
          }

          // Leave balances are always global (not month-specific), always refresh
          if (data.leaveBalances) setLeaveBalances(data.leaveBalances);

          // Refresh attendance list only if it's for the currently displayed month
          if (isSameMonth) {
            refreshAttendanceData();
          }
        }
      }
    };

    SocketService.on("attendance_update", handleAttendanceUpdate);
    SocketService.on("leave_update", handleLeaveUpdate);
    SocketService.on("attendance_stats_update", handleStatsUpdate);

    return () => {
      SocketService.off("attendance_update", handleAttendanceUpdate);
      SocketService.off("leave_update", handleLeaveUpdate);
      SocketService.off("attendance_stats_update", handleStatsUpdate);
    };

  }, [location.state]);

  // 🟢 Fetch Past Days Setting
  useEffect(() => {
    PastDaysService.getPastDays(compId).then((res) => {
      const data = res.data || [];
      if (Array.isArray(data) && data.length > 0) {
        setPastDaysLimit(data[0].days);
      } else {
        setPastDaysLimit(0);
      }
    }).catch(err => {
      console.error("Error fetching past days:", err);
    });
  }, [compId]);



  // 🟢 Helper: Check Alternate Day Logic
  const isAlternateOff = (policyDay, dateInput) => {
    if (!policyDay.alternate || !policyDay.alternate_type) return false;

    // Standardize input date
    const date = moment(dateInput, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"]);
    if (!date.isValid()) return false;

    // Standardize policy base date
    const baseDate = moment(policyDay.alternate, ["YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY"]);
    if (!baseDate.isValid()) return false;

    // ❌ BLOCKING CHECK RESTORED: Prevent checking past dates
    if (date.isBefore(baseDate)) return false;

    // Day name check (ensure we are comparing same weekdays)
    if (date.format('dddd').toLowerCase() !== baseDate.format('dddd').toLowerCase()) return false;

    // Calculate week difference
    const diffWeeks = date.diff(baseDate, "weeks");

    const cycleMap = {
      alternate: 2,       // Every 2 weeks
      bialternate: 3,     // Every 3 weeks
      trialternate: 4,    // Every 4 weeks
      "monthly alternate": 5 // Every 5 weeks (~monthly)
    };

    const cycle = cycleMap[policyDay.alternate_type?.toLowerCase()] || 2;
    const status = policyDay.status || 'off'; // 'off' means the Base Date is an OFF day

    if (status === 'off') {
      return diffWeeks % cycle === 0;
    } else {
      return diffWeeks % cycle !== 0;
    }
  };


  // Implementation of isApplyable using the Attendance List itself as the source of truth for "Working Days"
  const isApplyable = (targetDateStr) => {
    // Find index of target date
    // Count valid working days between Target and Today.
    // If count < limit, return true.

    const today = moment().startOf('day');
    const target = moment(targetDateStr).startOf('day');

    if (target.isSameOrAfter(today)) return true; // Current/Future always allowed (if displayed)

    let count = 0;
    let curr = today.clone().subtract(1, 'day');

    // Loop backwards until we hit target
    while (curr.isSameOrAfter(target)) {
      // Check if curr is a working day
      // We can check against `attendanceList`?
      // BUT attendance list might be paginated or filtered by month.
      // If we look at previous month, we might no have data.

      // Fallback: Just count weekdays (Mon-Fri) as working days if no data?
      // Or just use the simple day limit for now to enable the UI, 
      // and let backend/AddLeaves enforce the strict policy?
      // User asked to "hide" it.
      // Let's try to be as accurate as possible with holidays.

      const inList = attendanceList.find(a => moment(a.date).isSame(curr, 'day'));
      let isWorking = true;

      if (inList) {
        if (inList.status === 'Off' || inList.status === 'Holiday') isWorking = false;
      } else {
        // 🟢 Fallback: Use Shift data from leaveBalances if available
        if (leaveBalances && leaveBalances.length > 0) {
          const policy = leaveBalances[0]; // All user policies share the same shift
          if (policy.attendance_days) {
            const dayName = curr.format("dddd").toLowerCase();
            const policyDay = policy.attendance_days.find(p => p.day.toLowerCase() === dayName);

            // Check if day is Inactive OR an Alternate Off day
            if (policyDay) {
              if (!policyDay.active) isWorking = false;
              else if (policyDay.alternate && isAlternateOff(policyDay, curr)) isWorking = false;
            } else {
              if (curr.day() === 0 || curr.day() === 6) isWorking = false;
            }
          } else {
            if (curr.day() === 0 || curr.day() === 6) isWorking = false;
          }
        } else {
          if (curr.day() === 0 || curr.day() === 6) isWorking = false;
        }
      }

      if (isWorking) count++;

      curr.subtract(1, 'day');
    }

    return count <= pastDaysLimit;
  }

  // Simplified version given complexity of missing data:
  // JUST CHECK IF within PastDaysLimit * 1.5 (buffer for weekends) ??
  // NO. Let's do the "Count from today" loop inside the render?
  // No, expensive.

  // Let's use the helper: `isApplyable`

  const formatDecimalToHMM = (val) => {
    if (val === null || val === undefined || val === "") return "0:00";
    if (typeof val === 'string' && val.includes(':')) return val; // 🟢 Preserve HH:MM strings directly

    const decimal = parseFloat(val);
    if (isNaN(decimal)) return "0:00";

    const hours = Math.floor(decimal);
    const minutes = Math.round((decimal - hours) * 60);
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  const parseTimeToDecimal = (timeStr) => {
    if (!timeStr || timeStr === "NaN" || timeStr === "-") return 0;
    if (typeof timeStr === 'string' && timeStr.includes(':')) {
      const [h, m] = timeStr.split(':').map(Number);
      if (!isNaN(h) && !isNaN(m)) return h + (m / 60);
    }
    const parsed = parseFloat(timeStr);
    return isNaN(parsed) ? 0 : parsed;
  };

  const getDecimalHours = (el) => {
    if (!el) return 0;

    const isToday = moment(el.date).isSame(moment(), "day");
    const hasPunchOut = el.timeout && el.timeout !== "-";

    // 🟢 TRUST BACKEND: If punch-out exists or it's not today, trust the backend's totalhours.
    // The backend now correctly handles lunch deduction snapshots.
    if (el.totalhours && el.totalhours !== "NaN" && (hasPunchOut || !isToday)) {
      return parseTimeToDecimal(el.totalhours);
    }
    // Fallback: calculate from timein/timeout
    if (el.timein && el.timein !== "-") {
      const recordDate = moment(el.date).format("YYYY-MM-DD");
      const startTime = moment(`${recordDate} ${el.timein}`, ["YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]);

      // End Time: Timeout OR Today's Current Time (if no punch out yet)
      let endTime = moment(`${recordDate} ${el.timeout}`, ["YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]);
      if ((!el.timeout || el.timeout === "-") && moment(el.date).isSame(moment(), 'day')) {
        endTime = moment();
      }

      if (startTime.isValid() && endTime.isValid()) {
        let duration = moment.duration(endTime.diff(startTime)).asHours();

        // 🟢 Deduct Lunch overlap (Prioritize record snapshot)
        const activeLunch = (el.policy_lunch_times && el.policy_lunch_times.length > 0)
          ? el.policy_lunch_times
          : (moment(el.date).isSame(moment(), "day") ? todayLunchTimes : []);

        if (activeLunch && activeLunch.length > 0) {
          activeLunch.forEach(lunch => {
            if (lunch.start && lunch.end) {
              const lStart = moment(`${recordDate} ${lunch.start}`, ["YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]);
              const lEnd = moment(`${recordDate} ${lunch.end}`, ["YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]);
              if (lEnd.isBefore(lStart)) lEnd.add(1, "day");

              const overlapStart = moment.max(startTime, lStart);
              const overlapEnd = moment.min(endTime, lEnd);
              if (overlapEnd.isAfter(overlapStart)) {
                duration -= moment.duration(overlapEnd.diff(overlapStart)).asHours();
              }
            }
          });
        }
        return duration > 0 ? duration : 0;
      }
    }
    return 0;
  };

  const getTodayHours = () => {
    const decimalTotal = parseFloat(todayTotalHours);

    // 🟢 While still punched in, use client-side live calculation to avoid server clock lag
    // Also use live calculation if total is 0 but we have a checkout (prevents "0.00" stale display)
    if (activityCheckin && activityCheckin !== "" && (!activityCheckout || decimalTotal <= 0)) {
      // Fallthrough to live calculation below
    } else if (!isNaN(decimalTotal) && decimalTotal > 0) {
      return decimalTotal;
    }

    if (!activityCheckin || activityCheckin === "") return 0;

    const startTime = moment(activityCheckin, ["h:mm A", "HH:mm", "LT"]);
    const endTime = activityCheckout
      ? moment(activityCheckout, ["h:mm A", "HH:mm", "LT"])
      : moment();

    if (startTime.isValid() && endTime.isValid()) {
      let duration = moment.duration(endTime.diff(startTime)).asHours();

      // Deduct Lunch overlap to match backend totalhours
      if (todayLunchTimes && todayLunchTimes.length > 0) {
        todayLunchTimes.forEach(lunch => {
          if (lunch.start && lunch.end) {
            const lStart = moment(lunch.start, ["h:mm A", "HH:mm", "LT"]);
            const lEnd = moment(lunch.end, ["h:mm A", "HH:mm", "LT"]);

            const overlapStart = moment.max(startTime, lStart);
            const overlapEnd = moment.min(endTime, lEnd);
            if (overlapEnd.isAfter(overlapStart)) {
              duration -= moment.duration(overlapEnd.diff(overlapStart)).asHours();
            }
          }
        });
      }

      return duration > 0 ? duration : 0;
    }
    return 0;
  };



  const getTotalSum = (arr) => {
    var msgTotal = arr?.reduce(function (prev, cur) {
      const hours = getDecimalHours(cur);
      return prev + hours;
    }, 0);
    return parseFloat((msgTotal || 0).toFixed(2));
  };

  const calculateOvertime = (arr) => {
    return arr?.reduce((prev, cur) => {
      return prev + parseTimeToDecimal(cur.overtimeMinutes);
    }, 0) || 0;
  };

  const getAttendence = (isSilent = false) => {
    if (!isSilent) setLoading(true);
    AttendanceService.getAttendanceNew(compId, userid).then((res) => {
      const userData = res?.attandence?.[0] || res?.data?.attandence?.[0] || {};
      const Data = userData?.attandence || [];
      const WorkFromHome = userData?.wrokfrom_home;
      const Erole = userData?.role_title || "";

      // Always attach role
      const DataWithRole = Data.map((item) => ({
        ...item,
        role_title: Erole,
      }));

      const extractedName = userData?.full_name || `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim();
      if (extractedName) setEmpName(extractedName);

      setEmpRole(Erole);
      setWorkFromHome(WorkFromHome);
      setAttendenceList(DataWithRole);
      setOvertimeSummary(userData?.overtimeSummary || null);
      setIsOvertimeEnabled(userData?.overtimeAllowed !== false);
      setTargetMaritalStatus(userData?.personal_marital_status || DataParser.GetLoggedInUser()?.user?.userdata?.personal_marital_status || "");
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const getAttendenceById = (compId, id, isSilent = false) => {
    if (!isSilent) setLoading(true);
    AttendanceService.getAttendanceNew(compId, id).then((res) => {
      const userData = res?.attandence?.[0] || res?.data?.attandence?.[0] || {};
      const Data = userData?.attandence || [];
      const WorkFromHome = userData?.wrokfrom_home;
      const Erole = userData?.role_title || "";

      const DataWithRole = Data.map((item) => ({
        ...item,
        role_title: Erole,
      }));

      const extractedName = userData?.full_name || `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim();
      if (extractedName) setEmpName(extractedName);

      setEmpRole(Erole);
      setWorkFromHome(WorkFromHome);
      setAttendenceList(DataWithRole);
      setOvertimeSummary(userData?.overtimeSummary || null);
      setIsOvertimeEnabled(userData?.overtimeAllowed !== false);
      if (userData?.personal_marital_status) setTargetMaritalStatus(userData.personal_marital_status);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const getUserEntitlements = (u, c) => {
    LeaveEntitlementService.userLeaveEntitlement(u, c).then((res) => {
      const Data = res.data.entitlement;
      setUserEntitlementsList(Data);
    });
  };

  const getUserLeaves = (u, c) => {
    LeaveApplicationService.userLeave(u, c).then((res) => {
      const data = res.data.userLeaves;
      setUserLeaves(data);
    });
  };

  const refreshAttendanceData = async () => {
    const currentMonth = appliedMonthRef.current;
    const currentYear = appliedYearRef.current;
    const empId = location.state ? location.state.data : userid;

    if (currentMonth && currentYear) {
      try {
        const res = await AttendanceService.getAttendancebySearchNew(compId, empId, currentMonth, currentYear);
        const userData = res?.attandence?.[0] || res?.data?.attandence?.[0] || {};
        const Data = userData?.attandence || [];
        const Erole = userData?.role_title || "";
        const DataWithRole = Data.map((item) => ({ ...item, role_title: Erole }));

        const extractedName = userData?.full_name || `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim();
        if (extractedName) setEmpName(extractedName);

        setEmpRole(Erole);
        setAttendenceList(DataWithRole);
        setOvertimeSummary(userData?.overtimeSummary || null);
        if (userData?.personal_marital_status) setTargetMaritalStatus(userData.personal_marital_status);
      } catch (error) {
        console.error("Refresh Error:", error);
      }
    } else {
      if (location.state !== null) {
        await getAttendenceById(compId, empId);
      } else {
        await getAttendence();
      }
    }
  };

  const UpdateAttendacne = async () => {
    try {
      if (!editId) return;

      const timein = updatePunchIn ? updatePunchIn.format("h:mm A") : null;
      const timeout = updatePunchOut ? updatePunchOut.format("h:mm A") : null;

      const payload = {
        empid: location.state ? location.state.data : userid,
        timein,
        timeout,
      };

      const res = await AttendanceService.updateAttendance(editId, payload);

      if (res?.data?.Good) {
        message.success("Attendance updated successfully.");

        // Refresh attendance list from backend using ref-based state
        await refreshAttendanceData();

        setEditId(null);
        setUpdatePunchIn(null);
        setUpdatePunchOut(null);
      } else {
        message.error(res?.data?.message || "Failed to update attendance.");
      }
    } catch (error) {
      console.error("Update Attendance Error:", error);
      message.error("An error occurred while updating attendance.");
    }
  };


  // 🟢 Auto-reload when modal is fully closed
  useEffect(() => {
    const modalEl = document.getElementById("createAttendanceModal");
    if (!modalEl) return;

    const handleModalHidden = async () => {
      // ✅ Refresh attendance after modal fully closes using ref-based context
      await refreshAttendanceData();
    };

    modalEl.addEventListener("hidden.bs.modal", handleModalHidden);

    // 🟢 Listener for Offcanvas close to reset selected absent date
    const offcanvasEl = document.getElementById("applyLeaveOffcanvas");
    const handleOffcanvasHidden = () => {
      setSelectedAbsentDate(null);
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasHidden);
    }

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleModalHidden);
      if (offcanvasEl) {
        offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleOffcanvasHidden);
      }
    };
  }, []);


  const checkPunchIns = () => {
    const handlePunchinRes = (res) => {
      setStatus(res.data);
      setActivityCheckin(res.timein);
      setActivityCheckout(res.timeout);
      if (res.date) setActivityDate(res.date); // 🟢 Set Record Date
      if (res.totalhours) setTodayTotalHours(res.totalhours);
      if (res.lunch_times) setTodayLunchTimes(res.lunch_times); // ✅ Set lunch times from backend

      if (res.policy_start_time && res.policy_end_time && res.policy_start_time !== "-" && res.policy_end_time !== "-") {
        const s = moment(res.policy_start_time, ["HH:mm", "h:mm A", "LT"]);
        let e = moment(res.policy_end_time, ["HH:mm", "h:mm A", "LT"]);
        if (s.isValid() && e.isValid()) {
          if (e.isBefore(s)) e.add(1, "day");
          let exp = e.diff(s, "minutes");
          if (res.lunch_times && res.lunch_times.length > 0) {
            res.lunch_times.forEach(l => {
              if (l.start && l.end) {
                const ls = moment(l.start, ["HH:mm", "h:mm A", "LT"]);
                let le = moment(l.end, ["HH:mm", "h:mm A", "LT"]);
                if (le.isBefore(ls)) le.add(1, "day");
                exp -= le.diff(ls, "minutes");
              }
            });
          }
          setTodayExpectedHours(exp > 0 ? parseFloat((exp / 60).toFixed(2)) : null);
        }
      } else {
        setTodayExpectedHours(null);
      }

      if (res.punchout) {
        setIsDisable(res.punchout);
      }
    };

    if (location.state !== null) {
      const stateData = location?.state?.data;
      const Data = {
        company_id: compId,
        data: {
          empid: stateData,
          date: moment().format(),
        },
      };

      AttendanceService.attendanceCheckPunchinNew(Data).then(handlePunchinRes);
    } else {
      const Data = {
        company_id: compId,
        data: { empid: userid, date: moment().format() },
      };

      AttendanceService.attendanceCheckPunchinNew(Data).then(handlePunchinRes);
    }
  };

  const handelPunchIn = async (e) => {
    e.preventDefault();
    if (punchLoading.in) return;

    setPunchLoading((prev) => ({ ...prev, in: true }));
    const empId = location.state ? location.state.data : userid;

    const Data = {
      company_id: compId,
      data: {
        empid: empId,
        date: moment(),
        timeIn: currentTime,
        timeOut: "",
      },
    };

    try {
      const res = await AttendanceService.attendancePunchin(Data);
      if (!res.Good) {
        message.error(res.data || "Failed to punch in. Please try again.");
        return;
      }
      setStatus(res.data);
      message.success("Punched in successfully.");

      // ✅ Refresh table immediately
      await refreshAttendanceData();

      // Delay checkPunchIns to avoid reading stale DB state — the backend needs
      // a moment to commit the punch record before the check query returns it.
      setTimeout(() => checkPunchIns(), 1500);
    } catch (err) {
      console.error("Punch In Error:", err);
      message.error("Failed to punch in. Please try again.");
    } finally {
      setPunchLoading((prev) => ({ ...prev, in: false }));
    }
  };

  const handelPunchOut = async (e) => {
    e.preventDefault();
    if (punchLoading.out) return;

    setPunchLoading((prev) => ({ ...prev, out: true }));
    const empId = location.state ? location.state.data : userid;

    const Data = {
      company_id: compId,
      data: {
        empid: empId,
        date: moment(),
        timeOut: currentTime,
      },
    };

    try {
      const res = await AttendanceService.attendancePunchoutNew(Data);
      if (!res.Good) {
        message.error(res.data || "Failed to punch out. Please try again.");
        return;
      }
      setStatus(res.data);
      message.success("Punched out successfully.");

      // ✅ Refresh table immediately
      await refreshAttendanceData();

      // Delay checkPunchIns to avoid reading stale DB state
      setTimeout(() => checkPunchIns(), 1500);
    } catch (err) {
      console.error("Punch Out Error:", err);
      message.error("Failed to punch out. Please try again.");
    } finally {
      setPunchLoading((prev) => ({ ...prev, out: false }));
    }
  };

  const handelUpdateAttendance = async (e) => {
    e.preventDefault();

    // ✅ Wait for attendance update to finish
    await UpdateAttendacne();

    // ✅ Close modal after update
    const modalEl = document.getElementById("createAttendanceModal");
    const modal = window.bootstrap.Modal.getInstance(modalEl);
    modal?.hide();
  };

  // 🟢 When clicking Edit
  const handelEdit = (e, item) => {
    e.preventDefault();

    setUpdatePunchIn(item.timein && item.timein !== "-" ? moment(item.timein, ["h:mm A", "HH:mm", "LT"]) : null);
    setUpdatePunchOut(item.timeout && item.timeout !== "-" ? moment(item.timeout, ["h:mm A", "HH:mm", "LT"]) : null);
    setEditId(item._id); // ✅ Use MongoDB _id
  };

  const onCancel = (e) => {
    e.preventDefault();
    setUpdatePunchIn(null);
    setUpdatePunchOut(null);
  };

  // const handelSearch = (e) => {
  //   e.preventDefault();

  //   const empId = location.state ? location.state.data : userid;

  //   AttendanceService.getAttendancebySearchNew(
  //     compId,
  //     empId,
  //     selectMonth,
  //     selectYear
  //   ).then((res) => {
  //     const userData = res?.data?.attandence?.[0] || {};
  //     const Data = userData?.attandence || [];
  //     const Erole = userData?.role_title || "";

  //     const DataWithRole = Data.map((item) => ({
  //       ...item,
  //       role_title: Erole,
  //     }));

  //     setEmpRole(Erole);
  //     setAttendenceList(DataWithRole);
  //   });
  // };

  const handelSearch = (e) => {
    e.preventDefault();

    const empId = location.state ? location.state.data : userid;

    setLoading(true);
    setAttendenceList([]); // Clear old list to prevent stale calculation flashes

    setAppliedMonth(selectMonth);
    setAppliedYear(selectYear);
    appliedMonthRef.current = selectMonth;
    appliedYearRef.current = selectYear;

    AttendanceService.getAttendancebySearchNew(
      compId,
      empId,
      selectMonth,
      selectYear
    ).then((res) => {
      const userData = res?.attandence?.[0] || res?.data?.attandence?.[0] || {};
      const Data = userData?.attandence || [];
      const Erole = userData?.role_title || "";

      const DataWithRole = Data.map((item) => ({
        ...item,
        role_title: Erole,
      }));

      const extractedName = userData?.full_name || `${userData?.first_name || ""} ${userData?.last_name || ""}`.trim();
      if (extractedName) setEmpName(extractedName);

      setEmpRole(Erole);
      setAttendenceList(DataWithRole);
      setOvertimeSummary(userData?.overtimeSummary || null);
      setLoading(false);
    }).catch(() => setLoading(false));
  };



  const GotoUser = (e, s) => {
    e.preventDefault();
    //alert(s)
    navigate(`/${DataParser.CompanyIdentifierRole()}/employee_leaves`, {
      state: { data: apiUser },
    });
  };



  //handel apex charts

  const series = [
    {
      name: "TotalHours", //will be displayed on the y-axis
      data: attendanceList?.map((es) => {
        const hrs = getDecimalHours(es);
        return parseFloat(hrs.toFixed(2));
      }),
    },
  ];

  const options = {
    colors: ["#0DDFAB"],
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        tools: {
          download: false, // <== line to add
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    tooltip: {
      y: {
        formatter: (val) => formatDecimalToHMM(val) + " hrs",
      },
    },
    xaxis: {
      categories: attendanceList?.map((es) =>
        moment(es.date).format("DD/MM/YYYY")
      ), //will be displayed on the x-asis
    },
  };

  const onChange = (date) => {
    if (!date) return;
    setSelectMonth(date.format("MM"));
    setSelectYear(date.format("YYYY"));
  };


  // ✅ Returns full month name
  const getMonthName = (monthNum) => {
    if (!monthNum) return "";
    return moment().month(Number(monthNum) - 1).format("MMMM");
  };

  // ✅ Check if applied month = current month OR no selection (default)
  const isCurrentMonth = () => {
    if (!appliedMonth || !appliedYear) return true; // Initial load defaults to current month
    const currentMonth = moment().format("MM");
    const currentYear = moment().format("YYYY");
    return appliedMonth === currentMonth && appliedYear === currentYear;
  };

  useEffect(() => {
    const fetchPunchInEligibility = async () => {
      try {
        const compId = DataParser.CompanyId();
        const userId = DataParser.UserId();
        const todayDate = moment().format("YYYY-MM-DD");

        const body = {}; // If your service expects a body
        const res = await AttendanceService.attendancePunchinEligibility(
          compId,
          userId,
          todayDate,
          body
        );



        if (res?.success) {
          // ✅ Store the eligibility object
          setPunchInEligibility(res);
        }
      } catch (err) {
        console.error("Error fetching punch-in eligibility:", err);
        setPunchInEligibility({ punchInAllowed: false }); // fallback
      }
    };

    fetchPunchInEligibility();

    UserServices.getUserSummary(compId)
      .then((res) => {
        if (res.Good && res.data.upcomingBirthdays7Days?.length > 0) {
          setUpcomingBirthday(res.data.upcomingBirthdays7Days);
        } else {
          setUpcomingBirthday([]);
        }
      })
      .catch((err) => console.error("Error fetching birthday summary:", err));
  }, []);


  return (
    <>
      <Helmet>
        <title>Attendance - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid px-2 px-md-3">
            <style>{`
                /* Global Filter Row Styles */
                .custom-filter.float-select-wrap .ant-picker {
                    height: 34px !important;
                    min-height: 34px !important;
                    border: 1.5px solid #F2F2F2 !important;
                    border-radius: 6px !important;
                    width: 100% !important;
                }
                
                .custom-filter.float-select-wrap .ant-picker-input > input {
                    line-height: 30px !important;
                    font-size: 13px !important;
                }

                .custom-filter.float-select-wrap label {
                    font-size: 11px !important;
                    font-weight: 600 !important;
                }

                .eval-action-btn {
                    height: 34px !important;
                    border-radius: 6px !important;
                    font-size: 13px !important;
                    font-weight: 600 !important;
                    padding: 0 15px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    box-shadow: none !important;
                    transition: all 0.2s ease !important;
                }

                /* Overtime modal filter: match picker height to eval-action-btn */
                #viewOvertimeReportModal .custom-filter.float-select-wrap .ant-picker {
                    height: 34px !important;
                    min-height: 34px !important;
                }
                #viewOvertimeReportModal .custom-filter.float-select-wrap .ant-picker-input > input {
                    font-size: 13px !important;
                    line-height: 30px !important;
                }

                .btn-green {
                    background-color: #0DDFAB !important;
                    border: 1px solid #0DDFAB !important;
                    color: white !important;
                }

                .btn-green:hover {
                    background-color: #0bc698 !important;
                    border-color: #0bc698 !important;
                    color: white !important;
                }

                .card, .card-body, .table-responsive, .listing-table-wrapper, 
                .listing-table, .listing-table thead, .listing-table tr, 
                .listing-table th, .listing-table td {
                    border-radius: 0 !important;
                    box-shadow: none !important;
                }

                .listing-table thead tr.tableHeaderbg th {
                    background-color: #F2F2F2 !important;
                    color: #212529 !important;
                    border: none !important;
                    font-weight: 600 !important;
                    font-size: 13px !important;
                    padding: 8px 12px !important;
                    border-radius: 0 !important;
                }

                /* Overtime modal — subtle group separators only, no harsh cell borders */
                #viewOvertimeReportModal .listing-table thead tr.tableHeaderbg th {
                    border: none !important;
                    border-bottom: 1px solid #e5e5e5 !important;
                }

                .listing-table tbody tr td { 
                    border-bottom: 1px solid #F2F2F2 !important; 
                    vertical-align: middle !important; 
                    font-size: 13px !important;
                }

                /* Action Column Alignment — high-specificity override beats listing-table tbody td */
                table.listing-table tbody td.tableset,
                .tableset {
                    text-align: left !important;
                    vertical-align: middle !important;
                    padding: 0 0 0 12px !important;
                    width: 52px !important;
                }

                .action-center-wrapper {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: flex-start !important;
                    width: 100% !important;
                    height: 100% !important;
                }

                .tableset a {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    width: 28px !important;
                    height: 28px !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    flex-shrink: 0 !important;
                }

                .tableset i {
                    line-height: 1 !important;
                    display: block !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    font-weight: 400 !important;
                }

                /* Responsive: page title */
                @media (max-width: 576px) {
                    h4.fw-bold { font-size: 18px !important; }
                }

                /* Responsive: remove left/right padding on mobile/tablet */
                @media (max-width: 991px) {
                    .page-content.Pagebody {
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    .page-content.Pagebody .container-fluid {
                        padding-left: 12px !important;
                        padding-right: 12px !important;
                    }
                }
                @media (max-width: 576px) {
                    .page-content.Pagebody .container-fluid {
                        padding-left: 8px !important;
                        padding-right: 8px !important;
                    }
                }

                /* Responsive: top cards row */
                .att-cards-row {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 16px;
                    width: 100%;
                }
                .att-cards-row .att-col {
                    flex: 1 1 300px;
                    min-width: 0;
                }
                @media (max-width: 991px) {
                    .att-cards-row .att-col {
                        flex: 1 1 calc(50% - 8px);
                    }
                }
                @media (max-width: 600px) {
                    .att-cards-row .att-col {
                        flex: 1 1 100%;
                    }
                }

                /* Responsive: filter row */
                @media (max-width: 768px) {
                    .att-filter-row {
                        justify-content: flex-start !important;
                    }
                    .att-filter-row .float-select-wrap {
                        width: 100% !important;
                        min-width: unset !important;
                    }
                    .att-filter-row .eval-action-btn {
                        width: 100% !important;
                    }
                }

                /* Responsive: overtime modal range picker */
                @media (max-width: 768px) {
                    #viewOvertimeReportModal .col-md-8,
                    #viewOvertimeReportModal .col-md-4 {
                        width: 100% !important;
                        margin-bottom: 8px;
                    }
                }
            `}</style>
            <div className="row mx-0">
              <div className="col-12 px-0">
                <div className="d-flex align-items-center justify-content-between" style={{ padding: "12px 0" }}>
                  <h4 className="mb-0 fw-bold" style={{ fontSize: "24px", color: "#1D1D1D" }}>
                    Attendance - <span style={{ color: "#0DDFAB" }}>{empName}</span>
                  </h4>
                </div>
              </div>

              <div className="col-12 px-0 mb-2">
                <div className="att-cards-row">



                  <div className="att-col d-flex flex-column">
                    {!punchineligibility && isLoading ? (
                      <div style={{ padding: '16px' }}>
                        <Skeleton height={22} width={160} borderRadius={6} style={{ marginBottom: 16 }} />
                        <Skeleton height={72} borderRadius={10} style={{ marginBottom: 12 }} />
                        <Skeleton height={72} borderRadius={10} style={{ marginBottom: 16 }} />
                        <Skeleton height={44} borderRadius={8} style={{ marginBottom: 8 }} />
                        <Skeleton height={44} borderRadius={8} />
                      </div>
                    ) : punchineligibility?.punchInAllowed || status ? (
                      <div className="card punch-status mb-2" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                        <div className="card-body" style={{ padding: "20px" }}>
                          <h5 className="card-title fw-bold mb-4" style={{ fontSize: "18px", color: "#333" }}>Today's Attendance</h5>
                          <div className="punch-det mb-4 p-3" style={{ backgroundColor: "rgba(13, 223, 171, 0.05)", borderRadius: "10px", border: "1px solid rgba(13, 223, 171, 0.3)" }}>
                            <h6 className="text-muted mb-1" style={{ fontSize: "13px" }}>{activityCheckin ? "Punched In at" : "Punch In at"}</h6>
                            <p className="fw-bold mb-0" style={{ color: "#444", fontSize: "15px" }}>
                              {activityDate ? moment(activityDate).format("MMMM D, YYYY") : moment().format("MMMM D, YYYY")} <span style={{ color: "#0DDFAB" }}>{activityCheckin || "--:--"}</span>
                            </p>
                            {isDisabled ? (
                              <div className="mt-2 pt-2 border-top">
                                <h6 className="text-muted mb-1" style={{ fontSize: "13px" }}>{activityCheckout ? "Punched Out at" : "Punch Out at"}</h6>
                                <p className="fw-bold mb-0" style={{ color: "#444", fontSize: "15px" }}>
                                  {activityDate ? moment(activityDate).format("MMMM D, YYYY") : moment().format("MMMM D, YYYY")} <span style={{ color: "#f46a6a" }}>{activityCheckout || "--:--"}</span>
                                </p>
                              </div>
                            ) : null}
                          </div>

                          <div className="punch-info mb-4">
                            <div className="punch-hours" style={{ textAlign: "center", position: "relative", display: "flex", justifyContent: "center" }}>
                              {(() => {
                                const totalHours = getTodayHours();
                                const hrs = Math.floor(totalHours);
                                const mins = Math.round((totalHours - hrs) * 60);
                                const label = hrs + ":" + mins.toString().padStart(2, "0");

                                let percentage = 0;
                                if (label && label.includes(":")) {
                                  const [hrs, mins] = label.split(":").map(Number);
                                  if (!isNaN(hrs) && !isNaN(mins)) {
                                    const totalHours = getTodayHours();
                                    const expected = todayExpectedHours !== null ? todayExpectedHours : dynamicTargets.daily;
                                    if (expected && expected > 0) {
                                      percentage = Math.min(100, (totalHours / expected) * 100);
                                    } else {
                                      percentage = 0;
                                    }
                                  }
                                }

                                const chartOptions = {
                                  chart: { height: 350, type: "radialBar" },
                                  plotOptions: {
                                    radialBar: {
                                      hollow: { size: "75%" },
                                      track: {
                                        background: "#f2f2f2",
                                        strokeWidth: "100%",
                                      },
                                      dataLabels: {
                                        show: true,
                                        name: { show: false },
                                        value: {
                                          show: true,
                                          fontSize: "18px",
                                          fontWeight: 700,
                                          color: "#333",
                                          offsetY: 10,
                                          formatter: (val) => label + " hrs",
                                        },
                                      },
                                    },
                                  },
                                  colors: ["#0DDFAB"],
                                  stroke: { lineCap: "round" },
                                };

                                return (
                                  <Chart
                                    key={percentage}
                                    options={chartOptions}
                                    series={[percentage > 0 && percentage < 1 ? 1 : percentage]}
                                    type="radialBar"
                                    height={300}
                                  />
                                );
                              })()}
                            </div>
                          </div>

                          {workFromHome === 1 && (
                            <div className="punch-btn-section d-flex justify-content-between mb-4 px-3 gap-2">
                              {/* Punch In Button */}
                              <button
                                type="button"
                                className={`btn w-100 py-2 fw-bold ${!status && !punchLoading.in ? "glow" : ""}`}
                                onClick={(e) => !status && !punchLoading.in && handelPunchIn(e)}
                                disabled={status || punchLoading.in}
                                style={{
                                  borderRadius: "50px",
                                  backgroundColor: !status && !punchLoading.in ? "#0DDFAB" : "#E9ECEF",
                                  borderColor: !status && !punchLoading.in ? "#0DDFAB" : "#E9ECEF",
                                  color: !status && !punchLoading.in ? "#fff" : "#74788d",
                                  height: "48px",
                                  fontSize: "16px",
                                  cursor: !status && !punchLoading.in ? "pointer" : "not-allowed"
                                }}
                              >
                                {punchLoading.in ? "Punching In..." : "Punch In"}
                              </button>

                              {/* Punch Out Button */}
                              {(() => {
                                const isMidnight = (() => {
                                  const now = new Date();
                                  return now.getHours() === 0 && now.getMinutes() >= 0;
                                })();
                                const punchOutDisabled = !status || isDisabled || isMidnight;

                                const disabled = punchOutDisabled || punchLoading.out;

                                return (
                                  <button
                                    type="button"
                                    className={`btn w-100 py-2 fw-bold ${!disabled ? "glow" : ""}`}
                                    onClick={(e) => !disabled && handelPunchOut(e)}
                                    disabled={disabled}
                                    style={{
                                      borderRadius: "50px",
                                      backgroundColor: !disabled ? "#f46a6a" : "#E9ECEF",
                                      borderColor: !disabled ? "#f46a6a" : "#E9ECEF",
                                      color: !disabled ? "#fff" : "#74788d",
                                      height: "48px",
                                      fontSize: "16px",
                                      cursor: !disabled ? "pointer" : "not-allowed"
                                    }}
                                  >
                                    {punchLoading.out ? "Punching Out..." : "Punch Out"}
                                  </button>
                                );
                              })()}
                            </div>
                          )}

                          <div className="statistics p-3" style={{ backgroundColor: "rgba(13, 223, 171, 0.05)", borderRadius: "10px", border: "1px solid rgba(13, 223, 171, 0.3)" }}>
                            <div className="row">
                              <div className="col-12 text-center">
                                <p className="text-muted mb-1" style={{ fontSize: "12px" }}>Lunch Hours</p>
                                <h6 className="fw-bold mb-0" style={{ color: "#444" }}>
                                  {todayLunchTimes && todayLunchTimes.length > 0
                                    ? todayLunchTimes.map(l => `${moment(l.start, ["h:mm A", "HH:mm"]).format("h A")} - ${moment(l.end, ["h:mm A", "HH:mm"]).format("h A")}`).join(", ")
                                    : "No lunch hours available"}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="card" style={{ borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", border: "none", overflow: "hidden" }}>
                        <img className="img-fluid" src="/assets/images/schedule.webp" alt="Non-working day" style={{ height: "100%", objectFit: "cover" }} />
                      </div>
                    )}

                    {/* Upcoming Birthdays Card Always Visible */}
                    <div className="card mt-0 flex-grow-1" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                      <div className="card-body p-3">
                        <div className="d-flex align-items-center mb-3">
                          <div className="icon-circle me-2" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", backgroundColor: "#0DDFAB" }}>
                            <FaCakeCandles style={{ color: "#1D1D1D" }} />
                          </div>
                          <h6 className="fw-bold mb-0" style={{ fontSize: "16px", color: "#333" }}>Upcoming Birthdays
                            <Tooltip title="Upcoming birthdays in the next 7 days.">
                              <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '10px', color: '#242424' }} />
                            </Tooltip>
                          </h6>
                        </div>

                        {isLoading ? (
                          <div>
                            {[1,2,3].map(i => (
                              <div key={i} className="d-flex justify-content-between align-items-center mb-2">
                                <Skeleton height={20} width={130} borderRadius={6} />
                                <Skeleton height={28} width={80} borderRadius={6} />
                              </div>
                            ))}
                          </div>
                        ) : upcomingBirthday && upcomingBirthday.length > 0 ? (
                          <div className="birthday-list">
                            {upcomingBirthday.map((b, index) => (
                              <div
                                key={index}
                                className="d-flex justify-content-between align-items-center p-2 mb-2"
                                style={{
                                  borderRadius: "8px",
                                  backgroundColor: index % 2 === 0 ? "#f8f9fa" : "transparent",
                                  transition: "all 0.2s ease",
                                  border: "1px solid rgba(13, 223, 171, 0.1)"
                                }}
                              >
                                <span style={{ fontWeight: "600", color: "#444" }}>{b.full_name}</span>
                                <span className="badge" style={{ backgroundColor: "#0DDFAB", color: "#fff", padding: "6px 10px", borderRadius: "6px" }}>{b.dob}</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center py-3 text-muted">
                            <i className="bi bi-info-circle me-1"></i> No Upcoming Birthdays
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="att-col d-flex flex-column">
                    <div className="card att-statistics mb-2" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                      <div className="card-body" style={{ padding: "20px" }}>
                        <h5 className="card-title fw-bold mb-3" style={{ fontSize: "16px", color: "#333" }}>
                          {!appliedMonth || !appliedYear || isCurrentMonth()
                            ? `Monthly Overview - ${moment().format("YYYY")}`
                            : `${getMonthName(appliedMonth)} ${appliedYear} Overview`}
                        </h5>
                        <div className="stats-list">
                          {isTargetsLoading || isLoading ? (
                            <div style={{ padding: '8px 0' }}>
                              <Skeleton height={60} borderRadius={10} style={{ marginBottom: 10 }} />
                              <Skeleton height={60} borderRadius={10} style={{ marginBottom: 10 }} />
                              <Skeleton height={60} borderRadius={10} style={{ marginBottom: 10 }} />
                              <Skeleton height={60} borderRadius={10} />
                            </div>
                          ) : (
                            <>
                              {isCurrentMonth() && (
                                <div className="stats-info mb-3 p-3" style={{ backgroundColor: "rgba(13, 223, 171, 0.05)", borderRadius: "10px", border: "1px solid rgba(13, 223, 171, 0.3)" }}>
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <span className="text-muted" style={{ fontSize: "13px" }}>Today Working Hours</span>
                                    <span className="fw-bold" style={{ color: "#333", fontSize: "13px" }}>
                                      {activityCheckin === "" ? "0:00" : formatDecimalToHMM(getTodayHours())}
                                      <small className="text-muted fw-normal ms-1">/ {parseFloat(((todayExpectedHours !== null ? todayExpectedHours : dynamicTargets.daily) || 0).toFixed(2))} hrs</small>
                                    </span>
                                  </div>
                                  <div className="progress" style={{ height: "6px", borderRadius: "10px", backgroundColor: "#eee" }}>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${DataParser.calculateTimePercentage(getTodayHours(), (todayExpectedHours !== null ? todayExpectedHours : dynamicTargets.daily) || 1)}%`,
                                        backgroundColor: "#0DDFAB",
                                        borderRadius: "10px"
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              <div className="stats-info mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="text-muted" style={{ fontSize: "13px" }}>
                                    {(!appliedMonth || !appliedYear || isCurrentMonth()) ? "Monthly Worked Hours" : "Monthly Completed Hours"}
                                  </span>
                                  <span className="fw-bold" style={{ color: "#333", fontSize: "13px" }}>
                                    {overtimeSummary
                                      ? formatDecimalToHMM(overtimeSummary.totalWorkedHours)
                                      : formatDecimalToHMM(getTotalSum(attendanceList))}
                                    <small className="text-muted fw-normal ms-1">/ {overtimeSummary ? parseFloat(overtimeSummary.totalRequiredHours) : parseFloat((dynamicTargets.monthly || 0).toFixed(2))} hrs</small>
                                  </span>
                                </div>
                                <div className="progress" style={{ height: "6px", borderRadius: "10px", backgroundColor: "#eee" }}>
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                      width: `${DataParser.calculateTimePercentage(overtimeSummary ? parseFloat(overtimeSummary.totalWorkedHours) : getTotalSum(attendanceList), overtimeSummary ? parseFloat(overtimeSummary.totalRequiredHours) : dynamicTargets.monthly || 1)}%`,
                                      backgroundColor: "#34c38f",
                                      borderRadius: "10px"
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="stats-info mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="text-muted" style={{ fontSize: "13px" }}>Hours Left</span>
                                  <span className="fw-bold" style={{ color: "#333", fontSize: "13px" }}>
                                    {overtimeSummary
                                      ? formatDecimalToHMM(overtimeSummary.totalHoursLeft)
                                      : formatDecimalToHMM(Math.max(0, (dynamicTargets.monthly || 0) - getTotalSum(attendanceList)))}
                                    <small className="text-muted fw-normal ms-1">/ {overtimeSummary ? parseFloat(overtimeSummary.totalRequiredHours) : parseFloat((dynamicTargets.monthly || 0).toFixed(2))} hrs</small>
                                  </span>
                                </div>
                                <div className="progress" style={{ height: "6px", borderRadius: "10px", backgroundColor: "#eee" }}>
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                      width: `${DataParser.calculateTimePercentage(overtimeSummary ? parseFloat(overtimeSummary.totalHoursLeft) : Math.max(0, (dynamicTargets.monthly || 0) - getTotalSum(attendanceList)), overtimeSummary ? parseFloat(overtimeSummary.totalRequiredHours) : dynamicTargets.monthly || 1)}%`,
                                      backgroundColor: "#f1b44c",
                                      borderRadius: "10px"
                                    }}
                                  />
                                </div>
                              </div>

                              {isOvertimeEnabled && (
                                <div className="stats-info">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <span className="text-muted" style={{ fontSize: "13px" }}>Overtime Hours</span>
                                    <span className="fw-bold" style={{ color: "#333", fontSize: "13px" }}>
                                      {overtimeSummary
                                        ? formatDecimalToHMM(overtimeSummary.totalOvertimeHours)
                                        : formatDecimalToHMM(calculateOvertime(attendanceList))} hrs
                                    </span>
                                  </div>
                                  <div className="progress" style={{ height: "6px", borderRadius: "10px", backgroundColor: "#eee" }}>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${DataParser.calculateTimePercentage(overtimeSummary ? parseFloat(overtimeSummary.totalOvertimeHours) : calculateOvertime(attendanceList), (overtimeSummary ? parseFloat(overtimeSummary.totalRequiredHours) : dynamicTargets.monthly || 210) * 0.1)}%`,
                                        backgroundColor: "#556ee6",
                                        borderRadius: "10px"
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Upcoming Holidays - Repositioned here */}
                    <div className="card mt-0 flex-grow-1" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                      <div className="card-body" style={{ padding: "20px" }}>
                        <div className="d-flex align-items-center mb-3">
                          <div className="icon-circle me-2" style={{ width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", backgroundColor: "#0DDFAB" }}>
                            <i className="bi bi-calendar-event" style={{ color: "#1D1D1D" }}></i>
                          </div>
                          <h5 className="card-title fw-bold mb-0" style={{ fontSize: "18px", color: "#333" }}>Upcoming Holidays
                            <Tooltip title="Upcoming company holidays.">
                              <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '10px', color: '#242424' }} />
                            </Tooltip>
                          </h5>
                        </div>

                        {isLoading ? (
                          <div>
                            {[1,2,3].map(i => (
                              <div key={i} className="d-flex justify-content-between align-items-center mb-2">
                                <Skeleton height={20} width={140} borderRadius={6} />
                                <Skeleton height={28} width={90} borderRadius={6} />
                              </div>
                            ))}
                          </div>
                        ) : holidays?.latestUpcomingHolidays?.length > 0 ? (
                          <div className="holiday-list">
                            {holidays.latestUpcomingHolidays.slice(0, 2).map((event, index) => (
                              <div
                                key={index}
                                className="d-flex justify-content-between align-items-center p-2 mb-2"
                                style={{
                                  borderRadius: "8px",
                                  backgroundColor: index % 2 === 0 ? "#f8f9fa" : "transparent",
                                  transition: "all 0.2s ease"
                                }}
                              >
                                <span style={{ fontWeight: "500", color: "#444" }}>{event.name}</span>
                                <span className="badge bg-light text-dark border" style={{ fontSize: "12px" }}>{event.date}</span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center py-4 text-muted">
                            <i className="bi bi-info-circle me-1"></i> No Upcoming Holidays
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="att-col d-flex flex-column">
                    <div className="p-0 d-flex flex-column flex-grow-1">
                      <div className="card recent-activity mb-2" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                        <div
                          className="card-body"
                          style={{ padding: "20px" }}
                        >
                          <h5 className="card-title fw-bold mb-3" style={{ fontSize: "18px", color: "#333" }}>Working Hours Trend</h5>
                          {isLoading ? (
                            <Skeleton height={200} borderRadius={10} />
                          ) : (
                            <Chart
                              options={options}
                              type="area"
                              series={series}
                            />
                          )}
                        </div>
                      </div>

                      {/* Leave Balance & Total Absents Combined Section */}
                      <div className="d-flex flex-column gap-2 mb-3">
                        {/* Leave Balance Card */}
                        <div className="card flex-grow-1" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                          <div className="card-body p-3 py-3">
                            <h6 className="fw-bold mb-2 text-muted" style={{ fontSize: "16px", color: "#333" }}>Leave Balance
                              <Tooltip title="This shows your available leave balances in your Leave Types.">
                                <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '10px', color: '#242424' }} />
                              </Tooltip>
                            </h6>

                            {isLoading ? (
                              <div className="d-flex flex-wrap gap-2">
                                {[1,2,3].map(i => (
                                  <div key={i} className="px-3 py-2 rounded border d-flex align-items-center justify-content-between flex-grow-1" style={{ minWidth: "120px", backgroundColor: "#f8f9fa" }}>
                                    <Skeleton height={14} width={70} borderRadius={4} />
                                    <Skeleton height={18} width={36} borderRadius={4} />
                                  </div>
                                ))}
                              </div>
                            ) : leaveBalances.length > 0 ? (
                              <div className="d-flex flex-wrap gap-2">
                                {leaveBalances.filter(leave => {
                                  const name = (leave.leave_type_name || '').toLowerCase();
                                  if (name.includes('marriage')) {
                                    return targetMaritalStatus.toLowerCase() === 'single';
                                  }
                                  return true;
                                }).map((leave, index) => (
                                  <div key={index} className="px-3 py-2 rounded border d-flex align-items-center justify-content-between flex-grow-1" style={{ minWidth: "120px", backgroundColor: "rgba(13, 223, 171, 0.05)", borderColor: "rgba(13, 223, 171, 0.2)" }}>
                                    <span className="text-muted me-2" style={{ fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px" }}>{leave.leave_type_name}</span>
                                    <span className="fw-bold" style={{ fontSize: "14px", color: "#2c3e50" }}>
                                      {leave.remaining_leaves} <span style={{ fontSize: "10px", fontWeight: "500", color: "#adb5bd" }}>{leave.unit}</span>
                                    </span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-muted small fst-italic">No leave balance available.</div>
                            )}
                          </div>
                        </div>

                        {/* Total Absents Card */}
                        <div className="card flex-grow-1" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none", border: "none" }}>
                          <div className="card-body p-3 py-3">
                            <h6 className="fw-bold mb-2 text-muted" style={{ fontSize: "16px", color: "#333" }}>Total Absents
                              <Tooltip title="This shows your total cumulative absents.">
                                <i className="fa fa-info-circle ms-1" style={{ cursor: 'help', fontSize: '10px', color: '#000' }} />
                              </Tooltip>
                            </h6>
                            {isLoading ? (
                              <div className="px-3 py-2 rounded border d-flex align-items-center justify-content-between flex-grow-1" style={{ minWidth: "120px", backgroundColor: "#f8f9fa" }}>
                                <Skeleton height={14} width={70} borderRadius={4} />
                                <Skeleton height={18} width={50} borderRadius={4} />
                              </div>
                            ) : (
                              <div className="px-3 py-2 rounded border d-flex align-items-center justify-content-between flex-grow-1" style={{ minWidth: "120px", backgroundColor: "#fff5f5", borderColor: "#fecaca" }}>
                                <span className="text-danger me-2" style={{ fontSize: "11px", fontWeight: "600", letterSpacing: "0.5px" }}>ABSENTS</span>
                                <span className="fw-bold" style={{ fontSize: "14px", color: "#991b1b" }}>
                                  {Math.max(absentCount, (userLeaves || []).reduce((acc, curr) => {
                                    if (curr.status === 4 || curr.leave_type_name === "Absent Penalty") {
                                      return acc + (Number(curr.totalleaves) || 0);
                                    }
                                    return acc;
                                  }, 0))} <span style={{ fontSize: "10px", fontWeight: "500", color: "#f87171" }}>days</span>
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Filter Section */}
              <div className="col-12 px-0 mb-3">
                <div className="d-flex align-items-center justify-content-end gap-2 flex-wrap att-filter-row">
                  <div className="float-select-wrap has-value custom-filter" style={{ width: "200px", minWidth: "150px" }}>
                    <label>Select Month</label>
                    <DatePicker
                      picker="month"
                      className="w-100"
                      onChange={onChange}
                      format="MM/YYYY"
                      value={selectMonth && selectYear ? moment(`${selectYear}-${selectMonth}-01`, "YYYY-MM-DD") : null}
                      allowClear={false}
                    />
                  </div>

                  <button
                    onClick={(e) => handelSearch(e)}
                    className="btn btn-green eval-action-btn"
                  >
                    <i className="uil-search me-1"></i> Search
                  </button>

                  <CSVLink
                    className="btn btn-outline-dark eval-action-btn"
                    data={attendanceList}
                    filename={"attendance.csv"}
                    headers={headersCsv}
                    style={{ border: "1px solid #ECECEC", backgroundColor: "#fff", color: "#1D1D1D" }}
                  >
                    <i className="uil-cloud-download me-1"></i> CSV
                  </CSVLink>

                  <button
                    type="button"
                    className="btn btn-dark eval-action-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#viewOvertimeReportModal"
                  >
                    <i className="uil-clock me-1"></i> Report
                  </button>
                </div>
              </div>

              {/* this is for others */}
              <div className="col-12 px-0">
                <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th className="text-start ps-4">Date</th>
                            <th className="text-start">Day</th>
                            <th className="text-start">Punch In</th>
                            <th className="text-start">Punch Out</th>
                            <th className="text-start">Late In</th>
                            <th className="text-start">Early Out</th>
                            <th className="text-start">Working Hours</th>
                            {isOvertimeEnabled && <th className="text-start">Overtime</th>}
                            <th className="text-start">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={12} rows={6} />
                          ) : (
                            <>
                              {attendanceList && attendanceList.length > 0 ? (
                                attendanceList.map((el) => (
                                  <tr
                                    key={el._id || moment(el.date).format("YYYY-MM-DD")}
                                    className="text-start"
                                    style={{
                                      backgroundColor:
                                        el.status === "Holiday" ? "#fff5f5" :
                                          el.status === "Off" ? "#fffbeb" :
                                            el.status === "Leave" ? "#f0f7ff" :
                                              el.status === "Absent" ? "#fef2f2" : "transparent"
                                    }}
                                  >
                                    <td className="ps-4">
                                      <span>
                                        <i className="uil uil-calendar-alt me-1" style={{ color: "#0DDFAB", fontSize: "14px" }}></i>
                                        {moment(el.date).format("D, MMMM")}
                                      </span>
                                    </td>
                                    <td style={{ color: "#1d1d1d" }}>
                                      {moment(el.date).format("ddd")}
                                    </td>
                                    {((el.status === "Holiday" || el.status === "Off" || el.status === "Leave" || el.status === "Absent") &&
                                      (!el.isActive || !el.timein || el.timein === "-" || el.timein === "" || el.timein === "Holiday" || el.timein === "Leave" || el.timein === "Off")) ? (
                                      <td colSpan={isOvertimeEnabled ? "6" : "5"} className="text-center" style={{
                                        color:
                                          el.status === "Holiday" ? "#f46a6a" :
                                            el.status === "Off" ? "#f1b44c" :
                                              el.status === "Leave" ? "#556ee6" :
                                                el.status === "Absent" ? "#f46a6a" : "inherit",
                                        fontWeight: "bold",
                                        fontSize: "16px"
                                      }}>
                                        {el.status}
                                      </td>
                                    ) : (
                                      <>
                                        <td>
                                          {el.timein}
                                        </td>
                                        <td>
                                          {el.timeout}
                                        </td>
                                        <td>
                                          {el.lateInMinutes && el.lateInMinutes !== "0:00" ? el.lateInMinutes : "0:00"}
                                        </td>
                                        <td>
                                          {el.earlyOutMinutes && el.earlyOutMinutes !== "0:00" ? el.earlyOutMinutes : "0:00"}
                                        </td>
                                        <td>
                                          {formatDecimalToHMM(getDecimalHours(el))}
                                        </td>
                                        {isOvertimeEnabled && (
                                          <td>
                                            {el.overtimeMinutes && el.overtimeMinutes !== "0:00" ? el.overtimeMinutes : "0:00"}
                                          </td>
                                        )}
                                      </>
                                    )}
                                    <td className="tableset">
                                      <div className="action-center-wrapper">
                                        {el.status === "Absent" ? (
                                          isApplyable(el.date) ? (
                                            <Tooltip title="Apply Leave" placement="left">
                                              <Link
                                                to="#"
                                                className="cursor-pointer iconscolor"
                                                data-bs-toggle="modal"
                                                data-bs-target="#applyLeaveOffcanvas"
                                                onClick={() => setSelectedAbsentDate(el.date)}
                                              >
                                                <i className="uil-plus iconscolor" />
                                              </Link>
                                            </Tooltip>
                                          ) : (
                                            <Tooltip title="Past days limit exceeded" placement="left">
                                              <Link
                                                to="#"
                                                className="text-muted"
                                                style={{ cursor: "not-allowed", opacity: 0.5, display: "flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", margin: "0 auto" }}
                                                onClick={(e) => e.preventDefault()}
                                              >
                                                <i className="uil-ban" />
                                              </Link>
                                            </Tooltip>
                                          )
                                        ) : (
                                          (() => {
                                            const loggedInRole = DataParser.userRoleTitle()?.toLowerCase();
                                            const employeeRole = el.role_title?.toLowerCase() || emprole?.toLowerCase();
                                            if (!["hr", "company admin", "sub admin"].includes(loggedInRole)) return null;
                                            if (loggedInRole === "hr" && ["hr", "company admin", "admin"].includes(employeeRole)) {
                                              return null;
                                            }
                                            if (el.status !== "Present") return null;
                                            return (
                                              <Tooltip title="Edit Attendance" placement="left">
                                                <Link
                                                  to="#"
                                                  className="cursor-pointer iconscolor"
                                                  onClick={(e) => handelEdit(e, el)}
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#createAttendanceModal"
                                                >
                                                  <i className="uil-pen iconscolor" />
                                                </Link>
                                              </Tooltip>
                                            );
                                          })()
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    No attendance records found
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>{/* table-responsive */}
                  </div>{/* card-body */}
                </div>{/* card */}
              </div>{/* col-12 table */}
            </div>{/* row */}
          </div>{/* container-fluid */}
        </div>{/* page-content */}
      </div>{/* main-content */}
      <div
        id="createAttendanceModal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <form onSubmit={(e) => handelUpdateAttendance(e)}>
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content p-0" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
              <div className="modal-header border-0 px-4 pt-4 bg-white pb-0">
                <h5 className="modal-title fw-bold" id="myModalLabel" style={{ color: "#1D1D1D", fontSize: "1.1rem" }}>
                  Update Attendance
                </h5>
                <button
                  onClick={(e) => onCancel(e)}
                  type="button"
                  className="btn-close shadow-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body px-4 pt-3 pb-4 bg-white">
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className={`float-select-wrap ${updatePunchIn ? "has-value" : ""}`}>
                      <label>Punched in* <Tooltip title="Set punch in time." placement="top"><i className="fa fa-info-circle float-label-helper-icon" /></Tooltip></label>
                      <TimePicker
                        value={updatePunchIn}
                        onChange={setUpdatePunchIn}
                        format="h:mm a"
                        use12Hours
                        style={{ width: "100%" }}
                        allowClear={false}
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-4">
                    <div className={`float-select-wrap ${updatePunchOut ? "has-value" : ""}`}>
                      <label>Punched out* <Tooltip title="Set punch out time." placement="top"><i className="fa fa-info-circle float-label-helper-icon" /></Tooltip></label>
                      <TimePicker
                        value={updatePunchOut}
                        onChange={setUpdatePunchOut}
                        format="h:mm a"
                        use12Hours
                        style={{ width: "100%" }}
                        allowClear={false}
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    onClick={(e) => handelUpdateAttendance(e)}
                    type="submit"
                    className="btn btn-primary waves-effect waves-light fw-semibold"
                    style={{ backgroundColor: "#0DDFAB", borderColor: "#0DDFAB", borderRadius: "5px", fontSize: "14px", minWidth: "120px", height: "40px" }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div
        id="viewOvertimeReportModal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="overtimeReportLabel"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
          <div className="modal-content p-0" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
            <div className="modal-header border-0 px-4 pt-4 bg-white pb-0">
              <h5 className="modal-title fw-bold" id="overtimeReportLabel" style={{ color: "#1D1D1D", fontSize: "1.2rem" }}>
                Overtime Report
              </h5>
              <button
                type="button"
                className="btn-close shadow-none"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body px-4 pt-3 pb-3">
              {/* Filter Form */}
              <div className="row align-items-center mb-3">
                <div className="col-md-8">
                  <div className={`float-select-wrap custom-filter ${start && end ? "has-value" : ""}`}>
                    <label>Date Range</label>
                    <DatePicker.RangePicker
                      value={start && end ? [moment(start), moment(end)] : null}
                      onChange={(dates, dateStrings) => {
                        setIsAdjusted(false);
                        if (dates) {
                          setStartDate(dateStrings[0]);
                          setEndDate(dateStrings[1]);
                        } else {
                          setStartDate("");
                          setEndDate("");
                        }
                      }}
                      disabledDate={(current) => current && current >= moment().startOf('day')}
                      allowClear
                      separator=""
                      placeholder={['', '']}
                      suffixIcon={
                        <div style={{
                          backgroundColor: "#F4F4F4",
                          borderRadius: "6px",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "-4px"
                        }}>
                          <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                        </div>
                      }
                    />
                  </div>
                </div>
                <div className="col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-green eval-action-btn w-100 gap-2"
                    onClick={() => handleSearchOvertime()}
                    disabled={isOvertimeLoading}
                  >
                    {isOvertimeLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        Searching...
                      </>
                    ) : (
                      <>
                        <i className="uil-search" />
                        Search
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* 🔹 Refactored Report Table (Summary with Nested Overtime) */}
              <div className="col-lg-12">
                <div className="table-responsive listing-table-wrapper">
                  <table className="table mb-0 listing-table custom-table" style={{ fontSize: "11px", border: "1px solid #F2F2F2" }}>
                    {(() => {
                      const activeLogics = overtimeData?.summary?.overtimeLogics?.filter(l => l.active) || [];
                      const hasOT = overtimeData?.summary?.overtimeAllowed === "yes";

                      // Helper to generate sub-columns for a category based on its priority
                      const subColTooltips = {
                        shortage: "Hours of overtime used to fill Active Day working hour shortages.",
                        leaveMins: "Total overtime minutes converted into leave balance for this period.",
                        earned: "Number of leave days earned from overtime (0.5 = half day, 1.0 = full day).",
                        payMins: "Overtime minutes eligible for rate-based monetary payment.",
                        payAmt: "Calculated payment amount based on overtime rate × paid minutes.",
                        remaining: "Remaining overtime balance after all adjustments (shortage fill, leave, payment) have been applied.",
                      };

                      const getCategorySubColumns = (logic) => {
                        const cols = [];
                        const isHourlyPriority = logic.adjustment_priority === "Hourly Adjustment";

                        const hourlyCol = { label: "Hourly Fill", key: "shortage" };
                        const leaveCols = [
                          { label: "Leave Adj", key: "leaveMins" },
                          { label: "Leaves", key: "earned" }
                        ];
                        const payCols = [
                          { label: "Paid Mins", key: "payMins" },
                          { label: "OT Pay", key: "payAmt" }
                        ];

                        if (isHourlyPriority) {
                          if (logic.hourly_adjustment) cols.push(hourlyCol);
                          if (logic.leave_adjustment) cols.push(...leaveCols);
                        } else {
                          if (logic.leave_adjustment) cols.push(...leaveCols);
                          if (logic.hourly_adjustment) cols.push(hourlyCol);
                        }
                        if (logic.overtime_payment) cols.push(...payCols);

                        cols.push({ label: "Remaining", key: "remaining" });
                        return cols;
                      };

                      const categoryBlocks = activeLogics.map(l => ({
                        logic: l,
                        subCols: getCategorySubColumns(l)
                      }));

                      return (
                        <>
                          <thead>
                            <tr className="tableHeaderbg text-center align-middle">
                              <th className="text-center" rowSpan={2}>
                                Required Hours
                                <Tooltip title="Daily shift hours excluding lunch.">
                                  <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D' }} />
                                </Tooltip>
                              </th>
                              <th className="text-center" rowSpan={2}>
                                Worked
                                <Tooltip title="Actual hours worked during the period.">
                                  <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D' }} />
                                </Tooltip>
                              </th>
                              {hasOT && (
                                <>
                                  <th className="text-center" rowSpan={2}>
                                    Shortage
                                    <Tooltip title="Total deficit in working hours.">
                                      <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D' }} />
                                    </Tooltip>
                                  </th>

                                  {/* OVERTIME Group (Raw Values) */}
                                  {activeLogics.length > 0 && (
                                    <th className="text-center" style={{
                                      fontSize: '11px',
                                      letterSpacing: '1px',
                                      fontWeight: 'bold'
                                    }} colSpan={activeLogics.length}>
                                      OVERTIME
                                      <Tooltip title="Gross overtime minutes calculated for this period.">
                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D' }} />
                                      </Tooltip>
                                    </th>
                                  )}

                                  {/* CATEGORY BREAKDOWN Blocks */}
                                  {categoryBlocks.map((block) => (
                                    <th key={`block_${block.logic.day_type}`} className="text-center" style={{
                                      fontSize: '11px',
                                      letterSpacing: '0.5px',
                                      fontWeight: 'bold',
                                      borderLeft: "1px solid #e0e0e0"
                                    }} colSpan={block.subCols.length}>
                                      {block.logic.day_type.toUpperCase()} ADJUSTMENTS
                                      <Tooltip title={
                                        { "Active Days": "Adjustments derived from overtime worked on regular working days.", "Off Days": "Adjustments derived from overtime worked on weekly off days.", "Holidays": "Adjustments derived from overtime worked on public holidays." }[block.logic.day_type] || "Category-specific overtime adjustments."
                                      }>
                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                                      </Tooltip>
                                    </th>
                                  ))}
                                </>
                              )}
                            </tr>
                            {hasOT && (
                              <tr className="tableHeaderbg text-center align-middle">
                                {activeLogics.map(l => (
                                  <th className="text-center" style={{ fontSize: '10px' }} key={`${l.day_type}_ot`}>
                                    {l.day_type}
                                    <Tooltip title={{ "Active Days": "Gross overtime earned on regular scheduled working days.", "Off Days": "Gross overtime earned on weekly off/rest days.", "Holidays": "Gross overtime earned on gazetted public holidays." }[l.day_type] || "Overtime for this day type."}>
                                      <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                                    </Tooltip>
                                  </th>
                                ))}

                                {categoryBlocks.flatMap((block) =>
                                  block.subCols.map((col, colIdx) => (
                                    <th key={`${block.logic.day_type}_${col.key}`} className="text-center" style={{
                                      fontSize: '9px',
                                      borderLeft: colIdx === 0 ? `1px solid #e0e0e0` : 'none',
                                    }}>
                                      {col.label}
                                      <Tooltip title={subColTooltips[col.key] || col.label}>
                                        <i className="fa fa-info-circle ms-1" style={{ fontSize: '10px', color: '#1D1D1D', cursor: 'help' }} />
                                      </Tooltip>
                                    </th>
                                  ))
                                )}
                              </tr>
                            )}
                          </thead>
                          <tbody>
                            {isOvertimeLoading ? (
                              <TableSkeleton cols={20} rows={6} />
                            ) : overtimeData?.summary ? (
                              <tr className="text-center align-middle text-dark">
                                <td className="fw-bold">{overtimeData.summary.totalShiftHours}</td>
                                <td>{overtimeData.summary.totalWorkedHours}</td>

                                {hasOT && (
                                  <>
                                    <td>{overtimeData.summary.netShortageHours}</td>

                                    {/* Overtime (Raw) */}
                                    {activeLogics.map(l => {
                                      const key = l.day_type === "Active Days" ? "activeDayOT" : l.day_type === "Off Days" ? "offDayOT" : "holidayOT";
                                      return <td key={`${l.day_type}_val`}>{overtimeData.summary[key]?.includes("=") ? overtimeData.summary[key].split("=")[1].trim() : overtimeData.summary[key] || "0:00"}</td>;
                                    })}

                                    {/* Category Breakdowns */}
                                    {categoryBlocks.flatMap(block => {
                                      const type = block.logic.day_type;
                                      const minsToHHMM = (mins) => {
                                        const h = Math.floor(mins / 60);
                                        const m = Math.floor(mins % 60);
                                        return `${h}:${String(m).padStart(2, "0")}`;
                                      };

                                      return block.subCols.map((col, colIdx) => {
                                        let val = "-";
                                        if (col.key === "shortage") val = minsToHHMM(overtimeData.summary.categoryShortageFilled?.[type] || 0);
                                        if (col.key === "leaveMins") val = minsToHHMM(overtimeData.summary.categoryLeaveMins?.[type] || 0);
                                        if (col.key === "earned") {
                                          val = `${(overtimeData.summary.categoryEarnedLeaves?.[type] || 0).toFixed(2)} Days`;
                                        }
                                        if (col.key === "payMins") val = minsToHHMM(overtimeData.summary.categoryPaymentMins?.[type] || 0);
                                        if (col.key === "payAmt") val = ((overtimeData.summary.categoryPaymentMins?.[type] || 0) / 60 * (block.logic.rate_payment || 0)).toFixed(2);
                                        if (col.key === "remaining") val = minsToHHMM(overtimeData.summary.categoryRemaining?.[type] || 0);

                                        const blockIdx = categoryBlocks.indexOf(block);
                                        const groupColor = blockIdx % 2 === 0 ? '#0DDFAB' : '#0BBC8C';

                                        return <td key={`${type}_cell_${col.key}`} style={{
                                          fontSize: '10px',
                                          borderLeft: colIdx === 0 ? `3px solid ${groupColor}` : undefined,
                                          fontWeight: col.key === 'remaining' ? 'bold' : 'normal'
                                        }}>
                                          {val}
                                        </td>;
                                      });
                                    })}
                                  </>
                                )}
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan="20" className="text-center">
                                  No report data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </>
                      );
                    })()}
                  </table>
                </div>
              </div>
            </div>

            <div className="modal-footer border-0 px-4 pt-0 pb-4 bg-white justify-content-end">
              {DataParser.CompanyUserPermissions().includes("adjustment-create") && (
                <button
                  type="button"
                  className="btn fw-semibold"
                  style={{ backgroundColor: "#0DDFAB", borderColor: "#0DDFAB", color: "#ffffff", borderRadius: "5px", fontSize: "14px", minWidth: "140px", height: "40px" }}
                  onClick={() => {
                    document.getElementById("triggerAdjustModal").click();
                  }}
                  disabled={isAdjustmentProcessing || !overtimeData || isAdjusted}
                >
                  {isAdjustmentProcessing ? "Processing..." : "Adjust Now"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>



      {/* Hidden trigger for confirm adjustment modal */}
      <span id="triggerAdjustModal" data-bs-toggle="modal" data-bs-target="#confirmAdjustmentModal" style={{ display: "none" }} />

      {/* Confirm Manual Adjustment Modal */}
      <div id="confirmAdjustmentModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
          <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px", backgroundColor: "#f8f9fa" }}>
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Confirm Manual Adjustment</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body pt-2 pb-2">
              <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>
                Are you sure you want to process manual adjustments for the selected dates?
              </p>
              <p style={{ fontSize: "13px", color: "#f1a52a", marginBottom: 0 }}>
                <i className="uil uil-exclamation-triangle me-1" />
                This will immediately grant leaves/payment and lock the period.
              </p>
            </div>
            <div className="modal-footer border-0 pt-1">
              <button
                type="button"
                className="btn fw-semibold"
                data-bs-dismiss="modal"
                style={{ backgroundColor: "#0DDFAB", borderColor: "#0DDFAB", color: "#ffffff", borderRadius: "5px", fontSize: "13px" }}
                onClick={() => handleManualAdjustment()}
              >
                Yes, Adjust All
              </button>
            </div>
          </div>
        </div>
      </div>

      <AddLeaves
        id="applyLeaveOffcanvas"
        labelledby="applyLeaveOffcanvasLabel"
        getLeaveApplicationsAll={() => {
          if (location.state !== null) {
            getAttendenceById(compId, location.state.data);
          } else {
            getAttendence();
          }
        }}

        preSelectedLeaveDate={selectedAbsentDate}
      />
    </>
  );
};

export default AttendanceEmploye;